import { render, staticRenderFns } from "./FileDownload.vue?vue&type=template&id=5e55f668&scoped=true"
import script from "./FileDownload.vue?vue&type=script&lang=ts"
export * from "./FileDownload.vue?vue&type=script&lang=ts"
import style0 from "./FileDownload.vue?vue&type=style&index=0&id=5e55f668&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e55f668",
  null
  
)

export default component.exports